import { Star } from "lucide-react";

const ITEMS = [
  "Ristoranti", "Hotel", "Bar & Caffetterie", "Saloni di Bellezza", "Centri Estetici",
  "Palestre", "Officine", "Boutique", "Studi Medici", "Pizzerie", "Studi Professionali", "Negozi di Quartiere",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display px-8 text-lg font-semibold tracking-wide text-slate-400">{item}</span>
        <Star className="h-4 w-4 fill-[#FBBC04] text-[#FBBC04]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="trust-marquee" className="overflow-hidden border-y border-slate-200/70 bg-[#F8FAFC] py-6">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
